import React from 'react'
import PropTypes from 'prop-types'

import { Box, Container, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import ProductDescriptionItem from 'artkive/components/PageSections/ProductDescriptionItem'
import { TrackButton } from 'artkive/components/Tracker'
import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import useSale from 'artkive/hooks/useSale'
import { digitalBullets } from 'artkive/pages/Digital'
import theme from 'artkive/utils/theme'

import DigitalStorageImg from 'images/ecom/home/DigitalStorage.png'
import DigitalStorageImgX2 from 'images/ecom/home/DigitalStorage-x2.png'

const useStyles = makeStyles(() => ({
  picture: {
    height: 'auto',
    maxWidth: '100%',
    width: '100%',
  },
}))

const DigitalStorage = ({ classes: classesProp = {}, mobileBottomSpacing = theme.spacings.section, ...props }) => {
  const isMobile = useMobileBreakpoint()
  const classes = useStyles()
  const { boxCheckoutUrl } = useSale()

  return (
    <Box pt={isMobile ? 1 : theme.spacings.section} pb={isMobile ? 0 : theme.spacings.section} {...props}>
      <Container disableGutters={isMobile}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Image
              srcSet={`${DigitalStorageImg}, ${DigitalStorageImgX2} 2x`}
              src={DigitalStorageImg}
              className={classes.picture}
              alt='Account application preview'
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              px={isMobile ? 2 : 10}
              pt={4}
              pb={isMobile ? mobileBottomSpacing : 4}
              bgcolor={isMobile ? theme.colors.white.main : undefined}
            >
              <Typography variant='h2' align={isMobile ? 'center' : 'left'}>
                Digital Storage
              </Typography>
              <Box lineHeight={1.6} mt={isMobile ? 1 : 3} mb={3}>
                <Typography gutterBottom variant='subtitle1' align={isMobile ? 'center' : 'left'}>
                  You will receive access to your digital images with your Kids Art Book or Framed Mosaic.
                </Typography>
              </Box>
              {digitalBullets.map(({ text }, index) => (
                <ProductDescriptionItem key={index} className={classesProp.bullet}>
                  {text}
                </ProductDescriptionItem>
              ))}
              <Box display='flex' justifyContent={isMobile ? 'center' : 'left'} mt={isMobile ? 4 : 6}>
                <TrackButton
                  color='primary'
                  href={boxCheckoutUrl}
                  size='large'
                  variant='contained'
                  trackerEvent={GET_BOX_CLICK}
                  trackerOptions={{
                    section: 'get_mosaics_banner',
                  }}
                >
                  Get My Box
                </TrackButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

DigitalStorage.propTypes = {
  classes: PropTypes.shape({
    bullet: PropTypes.string,
  }),
  mobileBottomSpacing: PropTypes.number,
}

export default DigitalStorage
